import { render } from "./BaseIframe.vue?vue&type=template&id=3afca9d2&scoped=true"
import script from "./BaseIframe.vue?vue&type=script&lang=js"
export * from "./BaseIframe.vue?vue&type=script&lang=js"

import "./BaseIframe.vue?vue&type=style&index=0&id=3afca9d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afca9d2"]])

export default __exports__